import $ from 'jquery';

export default class Banners {
  timerInterval = null;

  init() {
    let currentSponsoredAdSlot = window.currentSponsoredAdSlot;
    let currentPplAdSlot = window.currentPplAdSlot;
    const totalSponsoredAds = window.totalSponsoredAds;
    const totalPplAds = window.totalPplAds;

    if ($('.sponsored-ads-slot').length) {
      setInterval(() => {
        $('.sponsored-ads-slot,.ppl-ads-slot').find('.promoted-card.visible').removeClass('visible');
        currentSponsoredAdSlot = (currentSponsoredAdSlot === totalSponsoredAds) ? 1 : currentSponsoredAdSlot + 1;
        currentPplAdSlot = (currentPplAdSlot === totalPplAds) ? 1 : currentPplAdSlot + 1;
        setTimeout(() => {
          $('.sponsored-ads-slot').find(`.promoted-card:nth-child(${currentSponsoredAdSlot})`).addClass('visible');
          $('.ppl-ads-slot').find(`.promoted-card:nth-child(${currentPplAdSlot})`).addClass('visible');
        }, 250);

        clearInterval(this.timerInterval);
        this.startTimer(118);
      }, 120000);
    }

    this.startTimer(118);

    if ($('.sponsored-carousel').length) {
      $('.sponsored-carousel').slick({
        slidesToShow: 1,
        pauseOnFocus: true,
        pauseOnHover: true,
        swipeToSlide: true,
        centerMode: true,
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4000
      });
    }
  }

  startTimer(duration) {
    let timer = duration;
    let minutes;
    let seconds;
    this.timerInterval = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      $('.timer').text(`${minutes}:${seconds}`);

      timer -= 1;
      if (timer < 0) {
        timer = duration;
      }
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/banners.js